module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sparklines"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2 col-sm-offset-2"
  }, [_vm._v("\n        Label: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.label),
      expression: "label"
    }],
    attrs: {
      "placeholder": _vm.label
    },
    domProps: {
      "value": (_vm.label)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.label = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_vm._v("\n        Color: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.color),
      expression: "color"
    }],
    attrs: {
      "placeholder": _vm.color
    },
    domProps: {
      "value": (_vm.color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.color = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [(_vm.circle) ? _c('button', {
    staticClass: "button expanded",
    on: {
      "click": function($event) {
        _vm.circle = false
      }
    }
  }, [_vm._v("\n          Hide red dot\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.circle) ? _c('button', {
    staticClass: "button expanded",
    on: {
      "click": function($event) {
        _vm.circle = true
      }
    }
  }, [_vm._v("\n          Show red dot\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "button expanded",
    on: {
      "click": function($event) {
        _vm.generate()
      }
    }
  }, [_vm._v("\n          New random data\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-sm-offset-4",
    staticStyle: {
      "height": "150px"
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('sparklines', {
    ref: "sparks",
    attrs: {
      "color": _vm.color,
      "label": _vm.label,
      "circle": _vm.circle
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-sm-offset-4"
  }, [_vm._v("\n      Embed following code to get this sparkline:\n      "), _c('textarea', {
    staticClass: "html-viewer",
    attrs: {
      "disabled": "",
      "rows": "4"
    }
  }, [_vm._v("<sparklines color=\"" + _vm._s(_vm.color) + "\" \n  label=\"" + _vm._s(_vm.label) + "\" \n  circle=\"" + _vm._s(_vm.circle) + "\">\n</sparklines> ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71ae7aae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SparklinesContainer.vue
// module id = 43
// module chunks = 0